// Core
import { select, put } from 'redux-saga/effects';

// Instruments
import { selectCountryWorker } from 'bus/geo/saga/workers';
import { QUERY_PARAMS } from 'helpers/query';
import { searchActions } from 'bus/search/actions';
import { queriesActions } from 'bus/queries/actions';
import { generatePath, book } from 'routes/book';

export function* submitSearchWorker ({ payload: { queryId, targetPage = null }}) {
    const { query, location } = yield select((state) => ({
        query:    state.queries.get(queryId),
        location: state.router.location,
    }));

    const searchCountryId = query.get(QUERY_PARAMS.COUNTRY);

    if (searchCountryId) {
        yield put(queriesActions.changeQueryParam(QUERY_PARAMS.AUTOSTART, true, queryId));
        yield put(queriesActions.compileQueryString(queryId));

        let targetUri = targetPage;
        const hash = yield select(({ queries }) => queries.getIn([queryId, 'hash']));

        if (targetUri === null) {
            const targetCountry = yield selectCountryWorker(searchCountryId);

            targetUri = generatePath(book.countrySearchPage, {
                countryCode: targetCountry.code.toLowerCase(),
            });
        }

        if (!targetUri || location === targetUri) {
            window.location.hash = hash;
            yield put(searchActions.runSearch(queryId));
        } else {
            window.location = `${targetUri}#${hash}`;
        }
    }
}
